import moment from "moment-jalaali";

const TravellerItem = (props) => {
    const { traveller, fillPassengerInformation, openDeleteConfirm } = props;

    let passengerName = traveller.firstname + " " + traveller.lastname
    if (props.isHotel && traveller.firstnamePersian && traveller.lastnamePersian) {
        passengerName = traveller.firstnamePersian + " " + traveller.lastnamePersian
    }
    return (
        <tr>
            <td> {passengerName}</td>
            <td> {traveller.gender ? "مرد" : "زن"} </td>
            <td> {traveller.nationalId || traveller.passportNumber} </td>
            {!props.isHotel && <td> {traveller.passportExpirationDate ? moment(traveller.passportExpirationDate).format("YYYY/MM/DD") : "--"} </td>}
            <td> {traveller.birthDate ? moment(traveller.birthDate).format("YYYY/MM/DD") : "--"} </td>
            <td>
                <button
                    type="button"
                    className="button blue-btn small-btn min-w-55"
                    onClick={() => { fillPassengerInformation(traveller) }}
                >
                    انتخاب
                </button>

                <button
                    type="button"
                    className="button red-btn small-btn min-w-55 margin-start-light"
                    onClick={() => { openDeleteConfirm(traveller.id) }}
                >
                    حذف
                </button>

            </td>
        </tr>
    )
}

export default TravellerItem;